export { CustomElement } from './custom-element.class';


// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/forms/elements/classes/index.ts